<template>
    <v-form ref="questionnaireform"
            @submit.prevent
            @keyup.enter="pushEnterToChildComponent"
    >
        <transition name="slide-fade" v-if="currQuestionIndex=='0' || currQuestionIndex=='1' || currQuestionIndex=='2'">
            <v-img class="animation-world world-image" contain  src="images/Kreis.png"></v-img>
        </transition>
        <transition name="slide-fade" v-else>
            <icon-world class="animation-world world-component" :progressValue="progressValue" :topLevelIndex="topLevelIndex"></icon-world>
        </transition>
        <question
                ref="questionComponent"
                :questionIndexString="currQuestionIndex+''"
                @newQuestionIndex="updateCurrQuestionIndex"
                @noMoreQuestions="showScoringResult"
        ></question>

        <v-layout v-if="currQuestionIndex=='0'" row wrap>
            <v-flex xs8 sm10 offset-xs2 offset-sm1>
                <p style="width:100%;color:#009fdf;">
                    #vorausschauend&nbsp;&nbsp;&nbsp;#stolperfrei&nbsp;&nbsp;&nbsp;#in4minuten
                </p>
            </v-flex>
            <v-flex xs2 sm1>
                <div v-if="accepted" class="display-flex">
                    <div class="center-by-margin">
                        <img @click="updateCurrQuestionIndex('1')" class="ui-btn" src="icons/qa/ui/btnForward.svg" />
                    </div>
                </div>
            </v-flex>
        </v-layout>


    </v-form>

</template>

<script>
    import { mapGetters } from "vuex";
    import Question from "./Question";
    import IconWorld from "./IconWorld";
    export default {
        name: "Questionnaire",
        components: {IconWorld, Question},
        data () {
            return {
                currQuestionIndex: '1',
                prevQuestionIndex: '',
                nextQuestionIndex: '2'
            }
        },
        computed: {
            progressValue(){
                return ((this.topLevelIndex-1)/this.questionsCount*100);
            },
            topLevelIndex(){
                let indexes = this.currQuestionIndex.split('.');
                return indexes[0];
            },
            accepted(){
                return this.$store.getters['getDsAccepted'];
            },
            ...mapGetters("qa", {
                questionsCount: "getTotalNumberOfQuestions",
                questions: "getQuestions",
                question: 'getQuestionByIndexString'
            })
        },
        methods: {
            showScoringResult() {
                // this.$route.router.go('/recommendation');
                this.$store.dispatch('qa/setRecommendedProducts');
                this.$router.push('wait');
            },
            updateCurrQuestionIndex(index) {
                this.currQuestionIndex = index;
                this.prevQuestionIndex = this.question(index).prevQuestionIndex;
                this.nextQuestionIndex = this.question(index).nextQuestionIndex;
            },
            pushEnterToChildComponent(e){
                if(this.$refs.questionComponent.questionToShow.options.type=='input'){
                    this.$refs.questionComponent.handleKeyUpEnterInInputField(e);
                    return;
                }
                this.$refs.questionComponent.nextQuestion();
            }
        }
    }
</script>


<style>
    form {
        width: 100%;
    }
    .v-carousel {
        box-shadow: none !important;
        height: 50px;
    }
    .v-carousel__controls {
        background-color: transparent !important;
        color: #002EA7 !important;
    }
    .v-btn__content {
        color: #002EA7 !important;
    }
    .v-carousel__controls__item .v-icon {
        opacity: 0.5 !important;
    }
    button.v-btn--active .v-carousel__controls__item .v-icon {
        opacity: 1 !important;
        color: #002EA7 !important;
    }
    /* Cloud sizes */
    .animation-world{
        opacity: 1;
        width: 390px !important;
        max-width: 80% !important;
    }
    .animation-world.world-image{
        margin-top: 0em !important;
    }
    .animation-world.world-component{
        margin-top: 0em !important;
    }
    div.circle-cloud {
        transform: scale(0.75);
    }
    div.circle-cloud.reduced-size {
        transform: scale(0.5);
    }



    /* Transition */
    .slide-fade-enter-active {
        transition: all 1s ease;
    }
    .slide-fade-leave-active {
        transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */ {
        /* transform: scale(0); */
        opacity: 0;
    }

</style>
